import { render, staticRenderFns } from "./CreateEditTeamData.vue?vue&type=template&id=5b71cfa1&scoped=true"
import script from "./CreateEditTeamData.vue?vue&type=script&lang=js"
export * from "./CreateEditTeamData.vue?vue&type=script&lang=js"
import style0 from "./CreateEditTeamData.vue?vue&type=style&index=0&id=5b71cfa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71cfa1",
  null
  
)

export default component.exports